<template lang="html">

<div class="upload-img">
      <el-upload
        class="upload-demo"
        accept="image/*,.pdf"
        :on-success="handleSuccess"
        action="https://jsonplaceholder.typicode.com/posts/"
        :before-upload="beforeUpload"
        :on-remove="handleRemove"
        :on-progress="handleProgress"
        :show-file-list="false"
        list-type="picture">
        <el-button size="small" type="primary">
             <span v-if="fileList.length === 0">点击上传</span>
             <span v-else>更新图片</span>
        </el-button>
        <div slot="tip" class="el-upload__tip">只能上传 jpg/jpeg/png/pdf 文件，且不超过 2M</div>
      </el-upload>
      <div v-if="upstate!='wait'" class="imgCard">
          <el-progress v-if="upstate!='uploaded'" class="pgress" width="90" type="circle" :percentage="upgress"></el-progress>
          <img v-else src="" alt="">
      </div>
</div>

</template>

<script>
export default {
    props:['listType','limit'],
    data(){
        return{
            fileList: [],
            upstate:'wait',
            upgress:0
        }
    },
    methods:{
        beforeUpload:function(file){
            var isImage = file.type.split('\/')[0] === 'image';


            var isLt100M = file.size / 1024 / 1024 <= 2;
            if (!isLt100M) {
                this.$message.error('文件大小不能超过 2 MB!');
            }else{
                // this.postHead['X-Token'] = getToken();
                // this.postData.organizationMaterialId = this.id;
                // this.postData.code = this.code;
            }

            if(!isImage){
                this.$message.error('只能上传格式为 jpg/jpeg/png/pdf 的文件');
            }

            if(isLt100M && isImage){
               this.upstate = 'uploading';
               return true;
            }
        },

        handleProgress:function(e,file,list){
            this.upgress = e.percent;
        },

        handleSuccess:function(res,flie,fileList){
            this.upstate = 'uploaded',
            this.upgress = 0;
        }
    }
}
</script>

<style lang="css" scoped>

.upload-img{
    width: 420px;
    padding-top: 2px;
}

.el-upload__tip{
    display: inline-block;
    margin-left: 12px;
}

.imgCard{
    width: 120px;
    height: 120px;
    border-radius: 6px;
    border:1px solid #F1F1F1;
    margin-top: 12px;
}

.imgCard .pgress{
   margin: 15px;
}

</style>



// WEBPACK FOOTER //
// imgUpload.vue?58367e4c